var map = {
	"./alert_camera.png": 44,
	"./alert_microphone.png": 45,
	"./alert_mute.png": 46,
	"./arrow-next.png": 47,
	"./arrow-repeat.png": 48,
	"./audio-icon.png": 49,
	"./avatars/AvatarArabella1.png": 50,
	"./avatars/AvatarArabella2.png": 51,
	"./avatars/AvatarArabella3.png": 52,
	"./avatars/AvatarArabella4.png": 53,
	"./avatars/AvatarArabella5.png": 54,
	"./avatars/AvatarChloe1.png": 55,
	"./avatars/AvatarChloe2.png": 56,
	"./avatars/AvatarChloe3.png": 57,
	"./avatars/AvatarChloe4.png": 58,
	"./avatars/AvatarChloe5.png": 59,
	"./avatars/AvatarChloe6.png": 60,
	"./camera.png": 61,
	"./close-icon.png": 62,
	"./dev_next.png": 63,
	"./dev_prev.png": 64,
	"./difficulty_1.png": 65,
	"./difficulty_1_a.png": 66,
	"./difficulty_1_b.png": 67,
	"./difficulty_2.png": 68,
	"./difficulty_2_a.png": 69,
	"./difficulty_2_b.png": 70,
	"./difficulty_3.png": 71,
	"./difficulty_3_a.png": 72,
	"./difficulty_3_b.png": 73,
	"./difficulty_4.png": 74,
	"./difficulty_4_a.png": 75,
	"./difficulty_4_b.png": 76,
	"./difficulty_5.png": 77,
	"./difficulty_5_a.png": 78,
	"./difficulty_5_b.png": 79,
	"./difficulty_6.png": 80,
	"./difficulty_6_a.png": 81,
	"./difficulty_6_b.png": 82,
	"./dummy_image_chicken.png": 83,
	"./dummy_image_cow.png": 84,
	"./dummy_image_duck.png": 85,
	"./dummy_image_horse.png": 86,
	"./dummy_image_mini-adventure.png": 87,
	"./dummy_image_pig.png": 88,
	"./dummy_image_sheep.png": 89,
	"./fantastisch.mp3": 90,
	"./ga_zo_door_2.mp3": 91,
	"./gevonden_rustig.mp3": 92,
	"./geweldig_1.mp3": 93,
	"./gewonnen_level_1_opgewekt.mp3": 94,
	"./gewonnen_level_2_opgewekt.mp3": 95,
	"./gewonnen_level_3_opgewekt.mp3": 96,
	"./gewonnen_level_4_opgewekt.mp3": 97,
	"./gewonnen_level_5_opgewekt.mp3": 98,
	"./gewonnen_level_6_opgewekt.mp3": 99,
	"./glow.png": 100,
	"./goed_gedaan.mp3": 101,
	"./goed_zo_2.mp3": 102,
	"./level_1_rustig.mp3": 103,
	"./level_2_rustig.mp3": 104,
	"./level_3_rustig.mp3": 105,
	"./level_4_rustig.mp3": 106,
	"./level_5_rustig.mp3": 107,
	"./level_6_rustig.mp3": 108,
	"./nog_een_keer.mp3": 109,
	"./ok_button.png": 110,
	"./prize_1.png": 111,
	"./prize_2.png": 112,
	"./prize_3.png": 113,
	"./prize_4.png": 114,
	"./prize_5.png": 115,
	"./prize_6.png": 116,
	"./progress.png": 117,
	"./super_opgewekt.mp3": 118,
	"./terug_2.mp3": 119,
	"./treasury.png": 120,
	"./verder_spelen.mp3": 121,
	"./wat_knap_2.mp3": 122,
	"./wauw_rustig.mp3": 123
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 137;


//////////////////
// WEBPACK FOOTER
// ../lib/assets/shared ^\.\/.*$
// module id = 137
// module chunks = 0